import { render } from "./ResumeLogoEditor.vue?vue&type=template&id=4710fb7d&scoped=true"
import script from "./ResumeLogoEditor.vue?vue&type=script&lang=js"
export * from "./ResumeLogoEditor.vue?vue&type=script&lang=js"

import "./ResumeLogoEditor.vue?vue&type=style&index=0&id=4710fb7d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4710fb7d"]])

export default __exports__